app.directive('validateOnBlur', [function() {
    return {
        require: 'ngModel',
        link: function($scope, elem, attrs, modelCtrl) {
            elem.on('blur', function() {
                modelCtrl.$dirty = true;
            });

            modelCtrl.$viewChangeListeners.push(function() {
                modelCtrl.$dirty = false;
            });

            $scope.$on('$destroy', function() {
                elem.off('blur');
            });
        }
    };
}]);